import React, { useCallback, useEffect, useState } from "react";

import DateTimePicker from "react-datetime-picker/dist/DateTimePicker";
import { GetDatePreriod, GetEnumValue } from "../../core/Helper";
import "./searchbar-ont.css";
import styled from "styled-components";
import { Dropdown, DropdownMenu, Form } from "react-bootstrap";

export function SearchBar(props) {
  const [dateRange, setDateRange] = useState([new Date(), new Date()]);
  const [dateSelected, setDateSelected] = useState(1);
  const { callback, inlineOption } = props;
  const [hospital, setHospital] = useState("");
  const [hn, setHn] = useState("");
  const [patientName, setPatientName] = useState("");
  const [modality, setModality] = useState(null);
  const [description, setDescription] = useState(null);
  // const [form, setForm] = useState(null);
  const [modalities, setModalities] = useState([]);

  useEffect(() => {
    loadModality();
    return () => {
      setModalities(null);
    };
  }, []);

  const loadModality = async () => {};

  const addWithAndOr = (condition, str) => {
    if (str.indexOf(condition, str) > 0) {
      return `${str}`;
    } else {
      return `and ${str}`;
    }
  };

  useEffect(() => {
    callbackAction();
  }, [dateRange]);

  useEffect(() => {
    callbackAction();
  }, [modality]);

  const callbackAction = (selectedOption) => {
    let cri = "";
    if (patientName) {
      cri += addWithAndOr(
        "and",
        `a.patients_name like \\'%${patientName}%\\' `
      );
    }
    if (hospital) {
      cri += addWithAndOr("and", `cu.cust_name like \\'%${hospital}%\\' `);
    }
    if (hn) {
      cri += addWithAndOr("and", `a.patientid like \\'%${hn}%\\' `);
    }
    if (modality) {
      cri += addWithAndOr("and", `a.modality like \\'%${modality}%\\' `);
    }

    if (description) {
      cri += addWithAndOr(
        "and",
        `a.study_description like \\'%${description}%\\' `
      );
    }

    cri = cri.substring(3, cri.length - 1);
    callback &&
      callback({
        dateRange,
        info: cri,
      });
  };

  // useEffect(() => {
  //   console.log("date xxx ", dateRange);
  // }, [dateRange]);

  const clearAction = () => {
    setHn(null);
    setModality(null);
    setHospital(null);
    setPatientName(null);
    setDateRange([new Date(), new Date()]);
  };

  const createButton = (index, text, dateStyle) => {
    return (
      <button
        onClick={() => setPreriod(dateStyle, index)}
        class={dateSelected === index ? "quick-btn-selected" : "quick-btn"}
      >
        {text}
      </button>
    );
  };

  const setPreriod = (dateStyle, index) => {
    setDateRange(GetDatePreriod(dateStyle));
    setDateSelected(index);
  };

  return (
    <div {...props} class="search-container">
      <div class="search-grid">
        <div class="search-field">
          <label class="search-label">From Date</label>
          <DateTimePicker
            className="search-input-date"
            name="date1"
            value={dateRange[0]}
            onChange={(e) => {
              setDateRange((pv) => {
                pv[0] = e;
                return { ...pv };
              });
            }}
            format="dd/MM/yyyy"
            locale="th-th"
            clearIcon={false}
          />
        </div>
        <div class="search-field">
          <label class="search-label">To Date</label>
          <DateTimePicker
            className="search-input-date"
            name="date2"
            value={dateRange[1]}
            onChange={(e) => {
              setDateRange((pv) => {
                pv[1] = e;
                return { ...pv };
              });
            }}
            format="dd/MM/yyyy"
            locale="th-th"
            clearIcon={false}
          />
        </div>

        <div class="search-field">
          <label class="search-label">โรงพยาบาล</label>
          <input
            type="text"
            class="search-input"
            onChange={(e) => setHospital(e.target.value)}
          />
        </div>
        <div class="search-field">
          <label class="search-label">HN</label>
          <input
            type="text"
            class="search-input"
            onChange={(e) => setHn(e.target.value)}
          />
        </div>
        <div class="search-field">
          <label class="search-label">Patient Name</label>
          <input
            type="text"
            class="search-input"
            onChange={(e) => setPatientName(e.target.value)}
          />
        </div>

        <div class="search-field" style={{ maxWidth: "80px" }}>
          <label class="search-label">Modality</label>
          <select
            class="search-input"
            onChange={(e) => setModality(e.target.value)}
          >
            <option value="">All</option>
            <option value="CT">CT</option>
            <option value="MR">MR</option>
            <option value="DX">DX</option>
            <option value="DR">DR</option>
            <option value="CR">CR</option>
          </select>
        </div>

        <div class="search-field">
          <label class="search-label">Description</label>
          <input
            type="text"
            class="search-input"
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>
      </div>

      <div class="quick-search">
        <div class="quick-search-left">
          {/* <span class="quick-search-label">Search for</span> */}

          <div class="search-field" style={{ maxWidth: "400px" }}>
            <label class="search-label">Search for</label>
            <div class="search-field-h-wrapper">
              {createButton(1, "1 วัน", "TODAY")}
              {createButton(2, "7 วัน", "LAST7DAYS")}
              {createButton(3, "30 วัน", "THISMONTH")}
              {createButton(4, "90 วัน", "LAST3M")}
            </div>
          </div>

          {inlineOption ? (
            <div class="search-field search-field-space h-space-adder">
              <label class="search-label">สถานะเคส</label>
              {inlineOption}
            </div>
          ) : (
            <></>
          )}
        </div>

        <div class="search-btn-wrapper-ont">
          <button
            class="search-btn"
            onClick={(e) => {
              callbackAction();
            }}
          >
            SEARCH
          </button>
          <button
            class="clear-btn"
            onClick={(e) => {
              clearAction();
            }}
          >
            Clear
          </button>
        </div>
      </div>
    </div>
  );
}

export default React.memo(SearchBar);

export const defaultStatusParams = {
  UN_COMPLETE: true,
  DELAY: true,
  RAD_ACCEPTED: false,
  RAD_REJECTED: false,
  OLD_STUDY: false,
  SCAN_COMPLETE: false,
  DIAG_DRAFT: false,
  DIAG_PRELIMINARY: false,
  DIAG_EDITED: false,
  FINALIZED: false,
  DIAG_COMPLETE: false,
};

export const StatusParamsValue = {
  APPOINT: 1,
  SCAN_COMPLETE: 2,
  UPLOADING: 3,
  UPLOADED: 4,
  RESULT_REQUES: 5,
  INFORM_ADM: 6,
  INFORM_RAD: 7,
  RAD_REJECTED: 8,
  RAD_ACCEPTED: 9,
  PAT_EDITED: 10,
  DIAG_DRAFT: 11,
  DIAG_PRELIMINARY: 12,
  DIAG_COMPLETE: 13,
  PRINT: 14,
  DIAG_VIEWED: 15,
  DIAG_EDITED: 16,
  FINAL: 17,
  REMOVE: 18,
  RAD_INFORMS: 19,
  PHY_INFORMS: 20,
  IMPORT: 21,
  OLD_STUDY: 22,
  UN_COMPLETE: 9,
};
const ParamInfo = {
  2: "รอส่งอ่าน",
  8: "แพทย์ปฏิเสธเคส",
  9: "All Except Complete",
  12: "Prelim",
  11: "Draft",
  13: "Complete",
  16: "Compete(แก้ไข)",
  22: "ส่งเคสเก่า",
};

export const convertParams = (p) => {
  let result = "";
  for (const key in p) {
    if (p[key] === true) {
      let id = StatusParamsValue?.[key];
      if (id) result += id + ",";
    }
  }
  if (result !== "") result = result.substring(0, result.length - 1);
  return result;
};

export const GetInlineOptions = (props) => {
  // console.log("test props vvvvv....", props);
  const { statusParam, setStatusParam, isDoctor } = props;
  const changedStatusCheck = (e) => {
    // console.log(e.target.name);

    setStatusParam((p) => {
      p["DELAY"] = false;
      p[e.target.name] = e.target.checked;
      return { ...p };
    });
  };

  // useEffect(() => {
  //   console.log("status params ", statusParam);
  // }, [statusParam]);

  const getParamsList = useCallback(() => {
    // console.log("pp");
    let pp = convertParams(statusParam);
    if (!pp) return;
    return (
      <DivStatusItemWrapper>
        {pp?.split(",")?.map((r) => {
          return <DivStatusItem>{ParamInfo[r]}</DivStatusItem>;
        })}
      </DivStatusItemWrapper>
    );
  }, [statusParam]);

  return (
    <DivWrapper>
      <Dropdown1>
        <Dropdown.Toggle>เฉพาะสถานะ</Dropdown.Toggle>
        <DropdownMenu1>
          {isDoctor ? (
            <Form.Check
              label="UN-Complete"
              name="UN_COMPLETE"
              onChange={changedStatusCheck}
              checked={statusParam?.UN_COMPLETE}
            />
          ) : (
            <></>
          )}
          <Form.Check
            label="Complete"
            name="DIAG_COMPLETE"
            onChange={changedStatusCheck}
          />
          <Form.Check
            label="Complete edited)"
            name="DIAG_EDITED"
            onChange={changedStatusCheck}
          />

          {isDoctor ? (
            <Form.Check
              label="Prelim"
              name="DIAG_PRELIMINARY"
              onChange={changedStatusCheck}
            />
          ) : (
            <></>
          )}
          {isDoctor ? (
            <Form.Check
              label="Draft"
              name="DIAG_DRAFT"
              onChange={changedStatusCheck}
            />
          ) : (
            <></>
          )}

          {!isDoctor ? (
            <Form.Check
              label="พ.รับเคส"
              name="RAD_ACCEPTED"
              onChange={changedStatusCheck}
            />
          ) : (
            <></>
          )}
          {!isDoctor ? (
            <Form.Check
              label="แพทย์ปฏิเสธเคส"
              name="RAD_REJECTED"
              checked={statusParam.RAD_REJECTED}
              onChange={changedStatusCheck}
            />
          ) : (
            <></>
          )}
          {!isDoctor ? (
            <Form.Check
              label="ส่งเคสเก่า"
              name="OLD_STUDY"
              onChange={changedStatusCheck}
            />
          ) : (
            <></>
          )}

          {!isDoctor ? (
            <Form.Check
              label="รอส่งอ่าน"
              name="SCAN_COMPLETE"
              onChange={changedStatusCheck}
            />
          ) : (
            <></>
          )}
        </DropdownMenu1>
      </Dropdown1>
      <DivStatusItemWrapper>{getParamsList()}</DivStatusItemWrapper>
    </DivWrapper>
  );
};

const Dropdown1 = styled(Dropdown)`
  display: flex;
  border: 1px solid var(--button-border-color);
  border-radius: 5px;
`;

const DropdownMenu1 = styled(DropdownMenu)`
  /* background-color: #0a58ca; // #1b1c2b; */
  background: var(--button-background);
  color: var(--button-text-color);
  padding-left: 15px;
  min-width: 220px;
`;

const DivWrapper = styled.div`
  display: flex;
  flex-direction: row;
  /* border: 1px solid blue; */
`;
const DivStatusItemWrapper = styled.div`
  display: flex;
  padding-inline: 5px;
  flex: 1;
`;
const DivStatusItem = styled.div`
  display: flex;
  font-size: 10px;
  font-family: sans-serif;
  padding: 5px 15px;
  background-color: #d2f0d4;
  color: #197008;
  margin-inline: 2px;
  border-radius: 10px;
  align-items: center;
  justify-content: center;
  max-height: 25px;
  margin-top: auto;
  margin-bottom: auto;
`;
